import { Button, Icon } from '@workramp/ui';
import { useTheme } from 'styled-components';
import Urls from '~/urls';
import { getAcademiesViewUrl } from '~/clc/features/academies/utils';

const {
  APP_CONSTANTS: { ASSET_PICKER_TYPES, NON_ASSET_PICKER_TYPES },
} = window;

export type ContentTypes = typeof ASSET_PICKER_TYPES.GUIDE | typeof ASSET_PICKER_TYPES.RESOURCE;

export type ParentTypes =
  | typeof NON_ASSET_PICKER_TYPES.ACADEMY_CERTIFICATION_CONTENT
  | typeof NON_ASSET_PICKER_TYPES.ACADEMY_COLLECTION_CONTENT
  | typeof NON_ASSET_PICKER_TYPES.ACADEMY_CUSTOM_PAGE_OBJECT;

interface SourceItemProps {
  id: string;
  type?: string;
  title: string;
  contentId: string;
  contentType: ContentTypes;
  parentId?: string;
  slug?: string;
}

function getUrl({ id, type, contentId, contentType, parentId, slug }: Omit<SourceItemProps, 'title'>) {
  if (parentId || slug) {
    // we're dealing with academy content if it has a parent id or slug prop
    // parentId is collection/cert_id
    // slug is for custom page objects
    return getAcademiesViewUrl({
      id,
      type,
      contentId,
      contentType,
      parentContentId: parentId,
      slug,
    });
  }

  return contentType === ASSET_PICKER_TYPES.GUIDE ? Urls.guideStart(id) : Urls.resourcePreview(id, null);
}

export const SourceItem = ({ id, type, title, contentId, contentType, parentId, slug }: SourceItemProps) => {
  const theme = useTheme();

  const iconName = contentType === ASSET_PICKER_TYPES.GUIDE ? 'guide:regular' : 'resource:regular';
  const iconColor =
    contentType === ASSET_PICKER_TYPES.GUIDE ? theme.colors.decorative.blue[500] : theme.colors.decorative.teal[500];

  const href = getUrl({ id, type, contentId, contentType, parentId, slug });

  return (
    <Button
      variant="outline"
      color="secondary"
      leadingIcon={<Icon name={iconName} color={iconColor} />}
      href={href}
      rel="noreferrer"
      target="_blank"
    >
      {title}
    </Button>
  );
};
